import { useState } from "react";
import PropTypes from "prop-types";
import { AsyncPaginate } from "react-select-async-paginate";
import { getEnvVariables } from "../../utils/helpers/getEnvVariables";

const SelectAsyncPaginateMunicipiosBogota = (props) => {
  const [itemsDonwload, setItemsDonwload] = useState({});
  const { API_URL } = getEnvVariables();

  const getDefaultValue = async () => {
    if (props.departamento) {
      const response = await fetch(
        `${API_URL}/utils/municipios/?departamento=${11}&page=${1}`
      );
      const responseJSON = await response.json();
      const defaultValue = responseJSON.results[0]
      props.onChange(defaultValue)
    }
  }

  const loadOptions = async (searchQuery, loadedOptions, { page }) => {
    let resp = itemsDonwload;
    let nextHas = null;
    if (searchQuery.length == 0) {
      const response = await fetch(
        `${API_URL}/utils/municipios/?departamento=${props.departamento}&page=${page}`
      );
      resp = await response.json();
      setItemsDonwload({
        ...resp,
        results: [...resp.results, ...(itemsDonwload?.results || [])],
      });
      nextHas = resp.next
    } else {
      resp = itemsDonwload
    }
    return {
      options: resp.results,
      hasMore: nextHas !== null,
      additional: {
        page: searchQuery ? 2 : page + 1,
      },
    };
  };

  const onChange = (option) => {
    if (typeof props.onChange === "function") {
      props.onChange(option);
    }
  };

  return (
    <AsyncPaginate
      styles={props.styles}
      key={JSON.stringify(props.departamento)}
      value={props.value || getDefaultValue}
      loadOptions={loadOptions}
      getOptionValue={(option) => option.nombre}
      getOptionLabel={(option) => option.nombre}
      onChange={onChange}
      placeholder="Seleccionar"
      additional={{
        page: 1,
      }}
      isSearchable
      filterOption={(option, inputValue) =>
        option.label.toLowerCase().includes(inputValue.toLowerCase())
      }
    />
  );
};

SelectAsyncPaginateMunicipiosBogota.propTypes = {
  departamento: PropTypes.number,
  value: PropTypes.any,
  onChange: PropTypes.func,
};

export default SelectAsyncPaginateMunicipiosBogota;